import { render, staticRenderFns } from "./StoreTemplatesModal.vue?vue&type=template&id=6e84db10"
import script from "./StoreTemplatesModal.vue?vue&type=script&lang=js"
export * from "./StoreTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e84db10')) {
      api.createRecord('6e84db10', component.options)
    } else {
      api.reload('6e84db10', component.options)
    }
    module.hot.accept("./StoreTemplatesModal.vue?vue&type=template&id=6e84db10", function () {
      api.rerender('6e84db10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Stores/Editor/StoreTemplatesModal.vue"
export default component.exports